// @flow
import React from 'react'
import createIcon from 'mz-icons/utils/createIcon'

export default createIcon({
  iconName: 'unionpay',
  icon: [
    100,
    66,
    null,
    null,
    null,
    <g fill="none" fillRule="evenodd" key="unionpay">
      <mask id="a" fill="#fff">
        <path d="M91.7 65.3H8.3A8.3 8.3 0 0 1 0 57.1v-49A8.2 8.2 0 0 1 8.3 0h83.4a8.3 8.3 0 0 1 8.3 8.2v49c0 4.5-3.8 8.2-8.3 8.1z" />
      </mask>
      <path
        fill="#DD2423"
        fillRule="nonzero"
        d="M9.7-7h29.4c4.1 0 6.6 3.5 5.7 8L31.1 63.5c-1 4.5-5 8-9.1 8H-7.5c-4 0-6.6-3.5-5.6-8L.6 1c1-4.4 5-8 9.1-8"
        mask="url(#a)"
      />
      <path
        fill="#16315E"
        fillRule="nonzero"
        d="M43-7h33.8c4 0 2.2 3.5 1.3 8L64.4 63.5c-1 4.5-.7 8-4.8 8H26c-4.1 0-6.7-3.5-5.7-8L33.9 1c1-4.4 5-8 9.1-8"
        mask="url(#a)"
      />
      <path
        fill="#036862"
        fillRule="nonzero"
        d="M78.9-7h29.4c4 0 6.6 3.5 5.7 8l-13.7 62.6c-1 4.5-5 8-9.2 8H61.8c-4.2 0-6.7-3.5-5.8-8L69.7 1c1-4.4 5-8 9.2-8"
        mask="url(#a)"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M22.3 23.7l-1.8 7.8c-.3 1.4-.6 2.5-1.5 3.1-.5.4-1.1.6-1.8.6-.4 0-.9 0-1.2-.3-.4-.3-.6-.7-.6-1.1v-.4l.3-2 2-7.5-4-.1v.5l-1.9 7.4-.1.7-.3 2c0 .6 0 1.1.4 1.6.8 1.3 3.1 1.5 4.4 1.5 1.6 0 3-.3 4.4-1 1.8-1 2.4-2.6 2.8-4l.2-.8 2-7.8h.1a29 29 0 0 1-3.4-.1zm10 13.7l-3 .1h-.1l.3-1.6.2-.7.6-2.7c0-.3.1-.9-.6-.9l-1 .3c0 .6-.4 2.2-.6 3l-.5 2.4-.1.1-3.1.1-.1-.1.7-2.8c.4-1.5.7-3.1.9-4.7h.1l3.3-.6.1.1-.2.8.7-.4c.6-.2 1.3-.4 2-.4s1.4.3 1.7.9c.2.7 0 1.4-.3 3l-.2.8-.7 3.2-.1.1zm4.9 0h-1.7l-1.6.1.4-1.2.7-3.2.3-1.4v-.1l1.7-.3 1.8-.2-.4 1.7-.4 1.6-.5 2-.2 1h-.1zm7.7-4c-.1.7-.3 1.3-.7 1.9-.2.3-.5.5-1 .5 0 0-.6 0-.6-.8 0-.5 0-.9.2-1.3.3-1.3.7-2.5 1.6-2.5.8 0 .8.8.5 2.2zm2.9-3c-.7-.7-1.8-1-3-1-1.3 0-2.5.4-3.6 1.2-.8.8-1.4 1.9-1.6 3-.3 1-.6 3 1.3 3.7.7.3 1.3.4 2 .3 1.4 0 2.8-.4 3.9-1.4.6-.8 1-1.7 1.3-2.7.4-1.7 0-2.6-.4-3zm31.8-.9l-3.4.5-.1.1v.3a2 2 0 0 0-1-.8c-.8-.2-2.3 0-3.6 1.2-.8.8-1.4 1.8-1.6 3-.3 1-.5 3 1.3 3.6a4 4 0 0 0 1.7.3c.6 0 1.2-.3 1.6-.7l-.1.5v.1h3.3l.1-.1 1-4.6.8-3.3zm-6 6.4c-.1 0-.7 0-.7-.8 0-.4 0-.9.2-1.3.3-1.3.7-2.4 1.6-2.4.7 0 1 .5.9 1.4l-.2.8-.3 1.1c0 .3-.2.5-.3.7-.3.3-.8.5-1.2.5zm-17.2 1.5l-3.1.1.3-1.6.2-.7.5-2.7c0-.3.1-.9-.5-.9-.4 0-.7.2-1 .3l-.6 3-.5 2.4-.2.1-3 .1-.2-.1.7-2.8c.5-1.5.8-3.1 1-4.7l3.3-.6.1.1-.2.8a5 5 0 0 1 2.8-.8c.7 0 1.3.3 1.7.9.2.7 0 1.4-.4 3l-.1.8-.7 3.2-.2.1zm10.4-13.6h-5l-.1.5-1 4-2.3 9.2H62l.6-2.9.5-1.8.3-.2h.2c2 0 4.2 0 6-1.3a6 6 0 0 0 2.5-4.8c0-.5-.2-1-.5-1.5-1-1.3-2.7-1.3-4.8-1.3zm-.3 6.3c-.7.3-1.5.4-2.3.3h-.5v-.2l1-4v-.4h.4l2.2.2c.8.3 1.1 1 .9 2a3 3 0 0 1-1.7 2zm-27.7-1.3c-1-.4-2-.3-2.7.3-.8.5-1 1.2-.3 1.6a3 3 0 0 0 2.7-.3c.8-.5 1-1.2.3-1.6zm50.9.7l-.1-.1-3.2.5h-.1v.1c-1 2.3-1 1.7-1.8 3.5v-.2l-.3-3.8v-.1l-3.2.5v.2l.2 2 .3 2.1.4 3.4-2.1 3.4-.7 1-.2.2a1 1 0 0 1-.4.1H78l-.6 1.7h1.9c.9 0 1.7-.4 2.2-1.1l1.1-2 7-11.4z"
        mask="url(#a)"
      />
    </g>,
  ],
})
